<template>
  <div
    class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full"
  >
    <div class="px-4 py-3 sm:px-4">
      <div
        class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap"
      >
        <div class="ml-4 mt-2">
          <h3 class="text-base leading-6 font-medium text-gray-900">
            {{ $t('message.reports.disp') }}: <b>{{this.currentDevice.name}}</b>
          </h3>
        </div>
        <div class="ml-2 mt-2 flex-shrink-0">
          <button
            @click="downloadExcel"
            type="button"
            class="relative inline-flex items-center px-2 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            <svg
              class="animate-spin -ml-1 mr-3 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            {{ $t('message.reports.detenciones.descargarexcel') }}
          </button>
        </div>
      </div>
    </div>
    <div class="px-4 py-6">
      <div id="chart3">
        <vue-apex-charts
          type="heatmap"
          height="250"
          :options="chartOptions"
          :series="series">
        </vue-apex-charts>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import { getUnixTime } from 'date-fns';
export default {
  name: 'report-disponibilidad',
  components: { VueApexCharts },
  mounted() {
    this.fetchData();
  },
  props: {
    range: {
      type: Object,
      required: true
    },
    currentDevice: {
      type: Object,
      required: true
    },
    reportnav: {
      type: Object
    }
  },
  watch: {
    range() {
      this.fetchData();
    },
    currentDevice() {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      const response = await this.$http.get(`/reports?report=disp&devid=${this.currentDevice.devid}&start=${start}&end=${end}`);
      console.log(response.data);
      this.series = response.data;

    },

    async downloadExcel() {
    }
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'heatmap',
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#008FFB"],
        title: {
          text: 'Disponibilidad diaria'
        },
      },
    };
  }
};
</script>
